// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeleton-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 50px;
  border-radius: 12px;
  width: 80%;
  max-width: 400px;
}

/* Línea animada tipo texto */
.skeleton-text {
  height: 14px;
  background: linear-gradient(90deg, #2b3544 25%, #3a4a5a 50%, #2b3544 75%);
  background-size: 200% 100%;
  animation: skeleton-loading 1.5s infinite ease-in-out;
  border-radius: 6px;
}

/* Variante más corta */
.skeleton-text.short {
  width: 50%;
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/chat/ChatSkeleton/ChatSkeleton.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,yEAAyE;EACzE,0BAA0B;EAC1B,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".skeleton-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px 50px;\n  border-radius: 12px;\n  width: 80%;\n  max-width: 400px;\n}\n\n/* Línea animada tipo texto */\n.skeleton-text {\n  height: 14px;\n  background: linear-gradient(90deg, #2b3544 25%, #3a4a5a 50%, #2b3544 75%);\n  background-size: 200% 100%;\n  animation: skeleton-loading 1.5s infinite ease-in-out;\n  border-radius: 6px;\n}\n\n/* Variante más corta */\n.skeleton-text.short {\n  width: 50%;\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
